import { createSelector } from 'reselect';

const loginUserInfo = (state) => state.login.userInfo;
const isAuthenticated = (state) => state.login.isAuthenticated;
const token = (state) => state.login.token;
const error = (state) => state.login.error;
const role=(state) => state.login.role;
const districtName=(state) => state.login.districtName;
const usercode = (state) => state.login.usercode;
export const getLoginUserInfo = createSelector([loginUserInfo], (data) => data);
export const getIsAuthenticated = createSelector([isAuthenticated], (data) => data);
export const getToken = createSelector([token], (data) => data);
export const getError = createSelector([error], (data) => data);
export const getRole = createSelector([role], (data) => data);
export const getDistrict = createSelector([districtName], (data) => data);
export const getUserCode = createSelector([usercode], (data) => data);
